<template>
  <div>
    <p>Tag points on the graph to provide feedback for AI training.</p>
    <el-form :model="this" label-width="8em" class="form-group">
      <el-form-item label="Tag Type">
        <el-select
          v-model="tagType"
          placeholder="Select tag type"
          class="w-full"
        >
          <el-option label="None" value="None"></el-option>
          <el-option label="Anomaly" value="Anomaly"></el-option>
          <el-option label="False" value="False"></el-option>
          <el-option label="True" value="True"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Note">
        <el-input
          type="textarea"
          v-model="note"
          placeholder="Enter your note"
          rows="3"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="flex flex-row justify-end">
      <el-button @click="handleCancel">Cancel</el-button>
      <el-button type="primary" @click="handleAddTag">Add Tag</el-button>
    </span>
  </div>
</template>

<script>
import { EventLogStatus } from "@/enums";
import { updateDashboardEvent } from "@/api";
export default {
  name: "AcknowledgeDialog",
  emits: ["confirm", "cancel"],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      tagType: "Anomaly",
      note: "",
    };
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    async handleAddTag() {
      this.loading = true;
      try {
        const payload = {
          eventIds: [this.id],
          tagInfo: { type: this.tagType, note: this.note },
          status: EventLogStatus.ACKNOWLEDGED,
        };
        await updateDashboardEvent(payload);
        this.$emit("confirm", payload);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.form-group {
  margin-bottom: 16px;
}
</style>
